export var DestroyType = /*#__PURE__*/function (DestroyType) {
  DestroyType["none"] = "none";
  DestroyType["max"] = "max";
  DestroyType["min"] = "min";
  return DestroyType;
}(DestroyType || {});